import React from 'react';
import OrderStep from "./OrderStep";
import {useMedia} from "react-use";

const Header = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    const isTablet = useMedia("(min-width: 768px) and (max-width: 991px)");


    const mobile = <div className="d-lg-none row">
                        <div className="col-12">
                            <div className="header-award" />
                        </div>
                        <div className="col-12">
                            <div className="header-banner" />
                        </div>
                        <h1 className="font-heading-xl font-weight-heading-xl col-12 bold">Ultra-fast business fibre with $0 installation </h1>
                        <div className="col-12 header-subheading font-xl font-weight-heading-small">Reliable internet for high-performing businesses</div><br/>
                        <div className="row p-0">
                            {
                                props.steps.map((item, key) => {
                                    return (
                                        <div key={key} className="col-xs-12 col-sm-4">
                                            <OrderStep itemKey={key} itemValue={item}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>;

    const tablet = <div className="d-lg-none">
                        <div className="col-12">
                            <div className="header-award" />
                        </div>
                        <div className="col-sm-7">
                            <h1 className="font-heading-xl font-weight-heading-xl bold">Ultra-fast business fibre with $0 installation </h1>
                            <div className="col-12 header-subheading font-xl font-weight-heading-small">Reliable internet for high-performing businesses</div><br/>
                        </div>
                        <div className="col-12 col-sm-5">
                            <div className="header-banner" />
                        </div>
                        <div className="col-sm-12 p-0">
                            {
                                props.steps.map((item, key) => {
                                    return (
                                        <div key={key} className="col-xs-12 col-sm-4">
                                            <OrderStep itemKey={key} itemValue={item}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>;

    return (
        <header className={`page-header header container pt-5 ${props.className ? props.className: ''}`}>
            <div className="row d-none d-lg-block">
                <div className="col-md-8 col-lg-7">
                    <div className="d-flex flex-column space-between">
                        <div className="header-award" />
                        <div>
                            <h1 className="font-heading-xl font-weight-heading-xl bold">Ultra-fast business fibre with $0 installation</h1>
                        </div>
                        <div className="header-subheading font-xl font-weight-heading-small">Reliable internet for high-performing businesses</div>
                    </div>
                </div>
                <div className="col-md-4 col-lg-5">
                    <div className="header-banner" />
                </div>
            </div>
            <div className="d-none d-lg-block">
                <div className="d-flex flex-row mt-5">{
                    props.steps.map((item, key) => {
                        return (
                            <OrderStep key={key} itemKey={key} itemValue={item}/>
                        )
                    })
                }</div>
            </div>

            {
                isMobile ? isTablet ? tablet: mobile: ''
            }

        </header>
    );
}

export default Header;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/Header.js